<template>
  <section>
    <div class="appendix" v-if="data.length">
      <el-table :data="data" style="width: 100%">
        <el-table-column label="文件名">
          <template slot-scope="scope">
            <file-link :item="scope.row"></file-link>
          </template>
        </el-table-column>
        <el-table-column prop="fileSize" width="150" label="文件大小">
        </el-table-column>
        <el-table-column prop="createTime" width="150" label="上传时间"></el-table-column>

        <el-table-column label="下载" width="120" align="center">
          <template slot-scope="scope">
            <a :href="baseURL+'/common/file/download?dz='+scope.row.fileUrl" target="_blank">
              <el-button size="mini">下载</el-button>
            </a>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="60" v-if="backRole('PM_4') || backRole('CT_3')">
          <template slot-scope="scope">
            <el-button size="mini" style="padding:5px;" type="danger" @click="iDelete(scope.row.id)"
              icon="el-icon-delete" circle>
            </el-button>
          </template>
        </el-table-column>


      </el-table>
    </div>
  </section>
</template>
<script>
  import Role from '@/Mixins/role'
  import FileLink from '@/components/FileLink'
  export default {
    props: ['data'],
    mixins: [Role],
    data() {
      return {
        baseURL: axios.defaults.baseURL
      }
    },
    components: {
      FileLink,
    },
    methods: {
      iDelete(id) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax.post('/common/file/del', {
            attaId: id
          }, (res) => {
            this.$emit('getFileList')
          })
        })
      }
      // fileDownload(url) {
      //   ajax.get('/common/file/download', {
      //     dz: url
      //   }, (res) => {
      //     console.log(res)
      //   })
      // },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/project/fileDownload.vue